export default __webpack_public_path__ + "static/media/logoutIcon.bfe476d6.svg";